import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { type IconDefinition, type IconName } from '@fortawesome/fontawesome-common-types';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';
import { NavigationService } from '@reconcept-platform/shared/navigation/nav-content';

@Component({
  selector: 'rcp-side-nav-item',
  template: `
    <div
      [rcpPopover]="tooltipText()"
      [rcpPopoverIsEnabled]="collapsed()"
      rcpPopoverPlacement="right"
      [class.header]="isHeader()"
      [class.expanded]="!collapsed()"
      class="item-container"
    >
      <ng-content select="[custom-icon]" />
      <rcp-list-item [icon]="itemIcon()" [label]="labelText()">
        <ng-content />
      </rcp-list-item>
    </div>
  `,
  styleUrls: ['./side-nav-item.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class SideNavItemComponent {
  private navigation = inject(NavigationService);

  label = input<string>();
  iconTyped = input<IconDefinition>();
  // @ts-expect-error TS2345 argument not assignable
  icon = input<IconName>(undefined);
  iconSolid = input<boolean>(false);
  align = input<'left' | 'right'>('left');
  popoverText = input<string>();

  expanded = input<boolean>();
  isHeader = input<boolean>(false);

  // @ts-expect-error TS2322 type not assignable
  labelText = computed<string>(() => (!this.collapsed() ? this.label() : ''));
  // @ts-expect-error TS2322 type not assignable
  tooltipText = computed<string>(() => (!this.popoverText() ? this.label() : this.popoverText()));
  // @ts-expect-error TS2345 argument not assignable
  itemIcon = computed<IconProp>(() => this.getIcon(this.iconTyped(), this.iconSolid(), this.icon()));
  collapsed = computed(() => this.navigation.sidebarIsCollapsed());

  private getIcon(iconTyped: IconDefinition, iconSolid: boolean, icon: IconName): IconProp {
    if (iconTyped) {
      return iconTyped;
    } else if (icon) {
      return [iconSolid ? 'fas' : 'far', icon];
    } else {
      // @ts-expect-error TS2322 type not assignable
      return undefined;
    }
  }
}
